import SamlDescription from './SamlDescription';

export default SamlDescription;
